import React from "react";
import "./GalleryTabs.css";



const GalleryTabs = ({ id, title, active, setSelected }) => {

  return (
    <li
      key={id}
      className={active ? "button active" : "button"}
      onClick={() => setSelected(id)}
    >
      {title} {/* Gallery Tab title */}
    </li>
  );

};

export default GalleryTabs;